/* eslint-disable no-undef */

import React, { Component } from "react";
// import { withScriptjs, withGoogleMap, GoogleMap } from "react-google-maps";
// import { MarkerWithLabel } from "react-google-maps/lib/components/addons/MarkerWithLabel";
import { Form, Input, Icon, notification } from "antd";
import { withRedux } from "../hoc";
import { LayoutPage, Button } from "../components";
import { createContactMessage } from "../services/page/contactmessage";
// import mapStyle from "./mapStyle";

// const logo = "/assets/images/logo.png";

// const position = { lat: 13.3069251, lng: 100.5471933 };
// const position = { lat: 12.780676, lng: 100.913544 };

// const MapComponent = withScriptjs(
//   withGoogleMap(props => (
//     <GoogleMap
//       options={{
//         styles: mapStyle,
//         streetViewControl: false,
//         scrollwheel: false,
//         mapTypeControl: false
//       }}
//       defaultZoom={15}
//       defaultCenter={position}
//     >
//       <MarkerWithLabel
//         position={position}
//         labelAnchor={new google.maps.Point(40, 60)}
//         // labelStyle={{ backgroundColor: '#40066c', padding: '5px 10px' }}
//         labelClass="marker-label-block"
//       >
//         <div className="marker-block" style={{ backgroundImage: `url('${logo}')` }} />
//       </MarkerWithLabel>
//     </GoogleMap>
//   ))
// );

const mapStateToProps = ({ language, t, contact }) => {
  return {
    language,
    t,
    contact: _.get(contact, "data")
  };
};

export default Form.create()(
  @withRedux(mapStateToProps)
  class Contact extends Component {
    submit = async values => {
      const result = await createContactMessage(values);
      const createStatus = _.get(result, "status");
      notification[createStatus === "success" ? "success" : "error"]({
        message: createStatus === "success" ? "We recieve your message" : "failed",
        duration: 3
      });
      if (createStatus === "success") {
        this.props.form.resetFields();
      }
    };
    handleSubmit = e => {
      e.preventDefault();
      this.props.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.submit(values);
        }
      });
    };

    render() {
      const { getFieldDecorator } = this.props.form;
      const { contact, t } = this.props;

      const video = _.get(contact, "video");
      const imageBanner = _.get(contact, "imageBanner");
      const imageBannerMobile = _.get(contact, "imageBannerMobile");

      return (
        <div className="contact-page">
          <LayoutPage
            type="primary"
            pageName="CONTACT TIFFANY’S SHOW PATTAYA"
            media={video}
            image={imageBanner}
            imageMobile={imageBannerMobile}
          />
          <div className="container-maps">
            <div className="container">
              {/* <MapComponent
                googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyDYd-QhCI4ARrA8qX10yMdBHnqUSU_tR0s&libraries=geometry,drawing,places"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={
                  <div
                    style={{
                      width: '100%',
                      height: `450px`,
                      position: 'relative'
                    }}
                  />
                }
                mapElement={<div style={{ height: `100%` }} />}
              /> */}
              {/* <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15553.630305117724!2d100.91007424871825!3d12.945751234600374!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x1764b7271889993e!2sTiffany's+Show+Pattaya+Co.%2C+Ltd.!5e0!3m2!1sth!2sth!4v1421482216174" scrolling="no" frameborder="0"></iframe> */}
              <iframe
                // width="1000"
                // height="450"
                title="contact maps"
                className="maps-iframe"
                src="https://maps.google.com/maps?q=tiffany%20show%20pa&t=&z=13&ie=UTF8&iwloc=&output=embed"
                // frameborder="0"
                // scrolling="no"
                // marginheight="0"
                // marginwidth="0"
              />
            </div>
          </div>
          <div className="container-contact-us">
            <div className="container">
              <div className="row">
                <div className="col-lg-7 col-md-12">
                  <div className="content">
                    <div className="title">
                      <h2>Tiffany's Show Pattaya Co., Ltd.</h2>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        {_.get(contact, "address") && (
                          <div className="contact-info">
                            <Icon type="environment" theme="filled" />
                            <p>{t(_.get(contact, "address"))}</p>
                          </div>
                        )}
                        {_.get(contact, "phones") && (
                          <div className="contact-info">
                            <Icon type="phone" theme="filled" />
                            <p>{_.join(_.map(_.get(contact, "phones"), v => v.phone), ", ")}</p>
                          </div>
                        )}
                        {_.get(contact, "faxs") && (
                          <div className="contact-info">
                            <Icon type="printer" theme="filled" />
                            <p>{_.join(_.map(_.get(contact, "faxs"), v => v.fax), ", ")}</p>
                          </div>
                        )}
                        {_.get(contact, "emails") && (
                          <div className="contact-info">
                            <Icon type="mail" theme="filled" />
                            <p>{_.join(_.map(_.get(contact, "emails"), v => v.email), ", ")}</p>
                          </div>
                        )}
                      </div>
                      <div className="col-md-6">
                        <h3>Reservations Department</h3>
                        {_.get(contact, "reservation_department_phones") && (
                          <div className="contact-info">
                            <Icon type="phone" theme="filled" />
                            <p>
                              {_.join(
                                _.map(
                                  _.get(contact, "reservation_department_phones"),
                                  v => v.phone
                                ),
                                ", "
                              )}
                            </p>
                          </div>
                        )}
                        {_.get(contact, "reservation_department_faxs") && (
                          <div className="contact-info">
                            <Icon type="printer" theme="filled" />
                            <p>
                              {_.join(
                                _.map(_.get(contact, "reservation_department_faxs"), v => v.fax),
                                ", "
                              )}
                            </p>
                          </div>
                        )}
                        {_.get(contact, "reservation_department_emails") && (
                          <div className="contact-info">
                            <Icon type="mail" theme="filled" />
                            <p>
                              {_.join(
                                _.map(
                                  _.get(contact, "reservation_department_emails"),
                                  v => v.email
                                ),
                                ", "
                              )}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 col-md-12">
                  <div className="form-email-block">
                    <Form onSubmit={this.handleSubmit}>
                      <Form.Item label="Name">
                        {getFieldDecorator("name", {
                          rules: [
                            {
                              required: true,
                              message: "Please input your name"
                            }
                          ]
                        })(<Input placeholder="Enter your name..." />)}
                      </Form.Item>
                      <Form.Item label="Email">
                        {getFieldDecorator("email", {
                          rules: [
                            {
                              required: true,
                              message: "Please input your email"
                            },
                            {
                              type: "email"
                            }
                          ]
                        })(<Input placeholder="Enter your email..." />)}
                      </Form.Item>
                      <Form.Item label="Phone">
                        {getFieldDecorator("phone", {
                          rules: [
                            {
                              required: true,
                              message: "Please input your phone number"
                            }
                          ]
                        })(<Input placeholder="Enter your number..." />)}
                      </Form.Item>
                      <Form.Item label="Message">
                        {getFieldDecorator("message", {
                          rules: [
                            {
                              required: true,
                              message: "Please input your message"
                            }
                          ]
                        })(<Input.TextArea autosize={{ minRows: 1, maxRows: 3 }} />)}
                      </Form.Item>
                      <Form.Item className="form-button-submit">
                        <Button ghost bordercolor="#ffb400" htmlType="submit">
                          Send
                        </Button>
                      </Form.Item>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/pages/Contact.js